<template>
  <div class="root">
    <ol class="zero-mp">
      <li v-for="c in list" class="crumb">
        <cms-link :blok="c"></cms-link>
      </li>
      <li class="current">{{ last.text }}</li>
    </ol>
  </div>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  mixins: [cms],
  name: "cms-breadcrumbs",
  computed: {
    list() {
      return this.blok.crumbs.slice(0, -1) || []
    },
    last() {
      return this.blok.crumbs[this.blok.crumbs.length - 1] || "N/A"
    }
  },
}
</script>

<style scoped>
ol {
  font-size: 0.9rem;
  gap: 5px;
  display: none;
  list-style: none;
  color: var(--crf-text);
}

ol li.crumb {
  display: flex;
  gap: 6px;
}

ol li.crumb::after {
  content: "/";
}

li.current {
  cursor: default;
  color: var(--crf-mute);
}

@media screen and (min-width: 768px) {
  ol {
    display: flex;
  }
}
</style>
